import React, { Fragment, useEffect, useState } from "react";
import loader from "../assets/images/plugin_loader.gif";
import notValid from "../assets/images/email_outlook_addon.png";
import notValidsabre from "../assets/images/hs_main.png";
import SuperAdmins from "./data/superadmin.json";
import { IntlProvider } from "react-intl";
import AppLocale from "../taskpane/lang";
import {
  gAPI_PROPERTY_DETAILS,
  gAPI_Email_Integrations,
  gAPI_ARI_INTEGRATION,
  gAPI_QUESTION_SET_DETAILS,
  gAPI_GROUP_DETAILS,
  gAPI_PROPERTIES,
} from "../constants/api";
import Main from "./main";
const PluginApp = ({ gid, pid, iid }) => {
  const [loading, setLoading] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState();
  const [emailIntegration, setEmailIntegration] = useState();
  const [questionSetDetails, setQuestionSetDetails] = useState();
  const [isValid, setIsValid] = useState(false);
  const [authContext, setAuthContext] = useState();
  const [locale, setLocale] = useState("");
  const [ariIntegration, setAriIntegration] = useState();
  const [service, setService] = useState(null);
  const [propertyList, setPropertyList] = useState([]);
  const [allowedProperty, setAllowedPropertyList] = useState([]);
  const [dynamicFlowList, setDynamicFlowList] = useState([]);
  const [groupId, setGroupId] = useState(gid);
  const [integrationId, setIntegrationId] = useState(iid);
  const [propertyId, setPropertyId] = useState();
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  const handleUpdateSettings = async ({ gid, iid }) => {
    console.log("Update Settings Called with gid:", gid, "iid:", iid);
    if (iid) {
      setIntegrationId(iid);
    }
    if (gid) {
      setGroupId(gid);
    }
    setLoading(true);
    await initialApi({ groupId: gid, integrationId: iid });
  }


  useEffect(() => {
    setLoading(true);
    console.log("Group ID:", groupId, "Integration ID:", integrationId, "Property ID:", propertyId);
    const callApi = async () => {
      await fetch(`${gAPI_PROPERTY_DETAILS}/${propertyId}?group_id=${groupId}`, {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setPropertyDetails(result);
        })
        .catch((err) => { });
      await fetch(gAPI_ARI_INTEGRATION + "?groupId=" + groupId + "&propertyId=" + propertyId, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then(async (json) => {
          if (json.Found === true && json.ShowRates === true) {
            setAriIntegration(json);
          }
        });
      // Fetch service provider
      setLoading(false);
    };
    const handleApi = async () => {
      await callApi();
      setLoading(false);
    };
    if (propertyId !== undefined && propertyId !== null) handleApi();
  }, [propertyId]);

  const initialApi = async ({ groupId, integrationId }) => {
    const authContext = await Office.auth.getAuthContext();
    await fetch(`${gAPI_GROUP_DETAILS}/${groupId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((result) => {
        if (result?.serviceProvider !== undefined && result?.serviceProvider !== null) {
          setService(result?.serviceProvider);
        } else {
          setIsValid(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error fetching service:", err);
        setIsValid(false);
        setLoading(false);
      });

    await fetch(`${gAPI_Email_Integrations}/${integrationId}?group_id=${groupId}`, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(async (result) => {
        if (result?.channelDetails && result?.channelDetails?.autonomousReplies) {
          let flow = result?.channelDetails?.autonomousReplies;
          let emailsData = result?.channelDetails?.addOn?.emails || [];
          setDynamicFlowList(result?.channelDetails?.autonomousReplies?.dynamicConversationFlow || []);
          if (flow?.versionDynamicFlow === "6DynamicConverstionFlow") {
            await fetch(`${gAPI_QUESTION_SET_DETAILS}?id=${flow?.assistantId}&platform=Email`, {
              method: "get",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((res) => res.json())
              .then(async (res) => {
                setQuestionSetDetails(res.result);
                setPropertyId(allowedProperty.length > 0 ? allowedProperty[0] : undefined);
              });
          }
          setAuthContext(authContext);
          await fetch(`${gAPI_PROPERTIES}/${groupId}`, {
            method: "get",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .then((json) => {
              if (json?.properties != null && json.properties.length > 0) {
                let lst = [];
                json.properties.map((m) => {
                  if (result.properties.filter((r) => r == m.id).length > 0) {
                    lst.push(m);
                  }
                });
                setPropertyList(lst);
                console.log("SuperAdmins", SuperAdmins, authContext);
                if (
                  emailsData.length > 0 &&
                  emailsData.filter(
                    (f) =>
                      f.email.toLowerCase() ===
                      authContext.userPrincipalName.toLowerCase()
                  ).length > 0
                ) {
                  const userEmailData = emailsData.filter(
                    (f) =>
                      f.email.toLowerCase() ===
                      authContext.userPrincipalName.toLowerCase()
                  )[0];
                  const emailList = userEmailData?.properties || [];
                  if (emailList !== undefined && emailList.length > 0) {
                    const permittedProperties = lst.filter((property) =>
                      emailList.some(
                        (allowedPropertyId) =>
                          String(allowedPropertyId) === String(property.id)
                      )
                    );
                    const permittedPropertyIds = permittedProperties.map(
                      (property) => property.id
                    );
                    console.log( "Inte properties:",lst,  emailList,   permittedPropertyIds);
                    setAllowedPropertyList(permittedPropertyIds);
                    setLocale(userEmailData?.language);
                    if (permittedProperties.length > 0) {
                      const selectedProperty =
                        permittedProperties.find(
                          (property) =>
                            String(property?.id) === String(pid)
                        ) || permittedProperties[0];

                      setPropertyId(selectedProperty.id);
                      setIsValid(true);
                    } else {
                      
                      setIsValid(false);
                    }
                  } else {
                    setAllowedPropertyList([]);
                    // setPropertyId(undefined);
                    setIsValid(false);
                  }
                  setLoading(false);
                }
                setEmailIntegration(result);
                if (
                  SuperAdmins?.data.length > 0 &&
                  SuperAdmins.data.filter((f) => f.toLowerCase() === authContext.userPrincipalName.toLowerCase())
                    .length > 0
                ) {
                  setIsSuperAdmin(true);
                  setAllowedPropertyList(lst.map((m) => m.id));
                  setPropertyId(lst[0].id);
                 // setLocale('en');
                  setIsValid(true);
                }
                setLoading(false);
              }
            })
            .catch((err) => {
              setLoading(false);
            });
        } else {
          setIsValid(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        setIsValid(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    const handleInitialApi = async () => await initialApi({ groupId, integrationId });
    handleInitialApi();
  }, [pid]);

  useEffect(() => {
    if (propertyId !== undefined && propertyId !== null && dynamicFlowList.length > 0) {
      let flowList = dynamicFlowList.filter((f) => f.propertyId === propertyId);
      if (flowList.length > 0) {
        fetch(`${gAPI_PROPERTY_DETAILS}/${propertyId}?group_id=${groupId}`, {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((result) => {
            setPropertyDetails(result);
          })
          .catch((err) => { });
      }
      if (flowList[0]?.dynamicConversationFlowId !== undefined && flowList[0]?.dynamicConversationFlowId !== null) {
        fetch(`${gAPI_QUESTION_SET_DETAILS}?id=${flowList[0]?.dynamicConversationFlowId}&platform=Email`, {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then(async (res) => {
            setQuestionSetDetails(res.result);
           // setPropertyId(allowedProperty[0]);
          })
          .catch((err) => {
          });
      }
    }
  }, [propertyId]);

  const handleProperty = (value) => {
    setPropertyId(value);
  };
  const currentAppLocale = AppLocale[locale === "" ? "en" : locale];
  console.log('languag', currentAppLocale, locale, AppLocale)
  return (
    <IntlProvider
      locale={currentAppLocale.locale}
      messages={currentAppLocale.messages}
    >
      <Fragment>
        {loading ? (
          <div className="sk-wrapper">
            <div className="sk-box">
              <div className="sk-line" />
              <div className="sk-line" />
              <div className="sk-line" />
              <div className="sk-line" />

              <div className="sk-gap" />

              <div className="sk-line l5" />
              <div className="sk-line l6" />
              <div className="sk-line l7" />
              <div className="sk-line l8" />
            </div>
          </div>
        ) : (
          <Fragment>
            {isValid ? (
              <Fragment>
                {propertyId !== undefined &&
                  propertyList &&
                  propertyList.length > 0 &&
                  allowedProperty &&
                  allowedProperty.length > 0 && (
                    <Main
                      locale={locale}
                      email={authContext.userPrincipalName}
                      ariIntegration={ariIntegration}
                      gid={groupId}
                      iid={integrationId}
                      pid={propertyId}
                      handleUpdateSettings={handleUpdateSettings}
                      isSuperAdmin={isSuperAdmin}
                      handleProperty={handleProperty}
                      propertyList={propertyList}
                      allowedProperty={
                        allowedProperty !== undefined && allowedProperty.length > 0 ? allowedProperty : propertyList
                      }
                      authContext={authContext}
                      propertyDetails={propertyDetails}
                      emailIntegration={emailIntegration}
                      questionSetDetails={questionSetDetails}
                      service={service}
                    ></Main>
                  )}
              </Fragment>
            ) : (
              <div>
                {service !== undefined && service !== null && service === "5" ? (
                  <img
                    className="item-center"
                    src={notValidsabre}
                    alt="not valid"
                    style={{ width: "90%", height: "90%" }}
                  />
                ) : (
                  <img className="item-center" src={notValid} alt="not valid" style={{ width: "90%", height: "90%" }} />
                )}
              </div>
            )}
          </Fragment>
        )}
      </Fragment>
    </IntlProvider>
  );
};
export default PluginApp;
